module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{},"zh-CHS":{}}')
  delete Component.options._Ctor
}
